var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-flex-layout",attrs:{"id":"app"}},[_c('NavBarComponent'),_c('div',{staticClass:"main-content"},[_c('router-view')],1),_c('FooterSectionComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }